import React from 'react';
import {
  makeStyles, Typography, Link, Button, Box,
} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import UserInfoSubInfo from 'common/components/UserInfoSubInfo';

const useStyles = makeStyles((theme) => ({
  reviewRow: {
    paddingBottom: theme.spacing(2),

    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.grey['100']}`,
    },

    [theme.breakpoints.up('md')]: {
      '&:not(:last-child)': {
        marginBottom: theme.spacing(5),
      },
    },

    [theme.breakpoints.up('lg')]: {
      paddingBottom: theme.spacing(4.5),
    },
  },
  user: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(3),

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  rating: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
  },
  ratingStars: {
    marginTop: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      marginTop: '0',
      justifyContent: 'flex-end',
    },
  },
  starIcon: {
    color: theme.palette.warning.main,
  },
  arrowRight: {
    marginLeft: theme.spacing(0.5),
  },
  reviewSubject: {
    fontWeight: 'bold',
  },
  reviewDes: {
    color: theme.palette.grey['300'],
  },
  reviewDetails: {
    position: 'relative',
    marginLeft: theme.spacing(0.5),

    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

const ReviewCard = (props) => {
  const {
    userImage, userName, verified, reviewDate, rate, bikeName, bikeHref, reviewDetails,
  } = props;
  const classes = useStyles();

  return (
    <>
      <Box className={classes.reviewRow} key={userImage}>
        <Box className={classes.user}>

          <UserInfoSubInfo
            image={userImage}
            name={userName}
            verified={verified}
            date={reviewDate}
          />

          <Box className={classes.rating}>
            {rate && (
            <Rating
              readOnly
              defaultValue={rate}
              precision={0.5}
              emptyIcon={<StarBorderIcon fontSize="inherit" />}
              className={classes.ratingStars}
              classes={{ root: classes.starIcon }}
            />
            )}

            {bikeHref && (
            <Button component={Link} href={bikeHref} color="secondray">
              {bikeName}
              <ChevronRightIcon className={classes.arrowRight} />
            </Button>
            )}
          </Box>
        </Box>

        {reviewDetails?.map((review) => (
          <Box className={classes.reviewDetails}>

            {review.subject && (
              <Typography variant="h5" className={classes.reviewSubject}>
                {review.subject}
              </Typography>
            )}

            {(review.rating || review.title) && (
            <Box mt={0.5} mb={1} display="flex" justifyContent="space-between" alignItems="center">

              {review.title && (
              <Typography variant="h5" className={classes.reviewSummary}>
                {review.title}
              </Typography>
              )}

              {review.rating && (
              <Rating
                readOnly
                defaultValue={review.rating}
                precision={0.5}
                emptyIcon={<StarBorderIcon fontSize="inherit" />}
                classes={{ root: classes.starIcon }}
              />
              )}
            </Box>
            )}

            {review.description && (
              <Typography variant="subtitle2" className={classes.reviewDes}>
                {review.description}
              </Typography>
            )}
          </Box>
        ))}

      </Box>
    </>
  );
};

export default ReviewCard;
